module.exports = __webpack_public_path__ + "img/pytest_exception_stacktrace.bf9cefb9.png";